import { Grid } from '@material-ui/core';
import { _t } from 'app/utils/i18n';
import { handleLongStringWithToolTip } from 'app/utils/stringMethods';
import parse from 'html-react-parser';
import React, { FunctionComponent } from 'react';

import styles from './Paragraph.module.scss';

interface Props {
  title?: string;
  isTemplate?: any;
  titleComp?: boolean;
  subTitleComp?: boolean;
  reportNameComp?: boolean;
  paragraphComp?: boolean;
  content?: string;
}

const Paragraph: FunctionComponent<Props> = ({
  title,
  isTemplate,
  titleComp,
  subTitleComp,
  reportNameComp,
  paragraphComp,
  content,
}) => {
  const header = titleComp
    ? ` ${_t('reports:title')} `
    : subTitleComp
    ? `${_t('reports:sub_title')}`
    : reportNameComp
    ? _t('reports:report_name')
    : _t('reports:paragraph');
  return (
    <Grid item sm={12}>
      <div className={styles.Paragraph}>
        <h3 dir="auto">{!content && !title && header}</h3>
        <h3 dir="auto">
          {paragraphComp
            ? parse(title || '')
            : header
            ? handleLongStringWithToolTip(content || '', isTemplate ? 180 : 120)
            : title}
        </h3>
      </div>
    </Grid>
  );
};

export default Paragraph;
